import { Route } from 'react-router-dom';
import { CreateCompanyPage } from './create-company';
import { EditCompanyPage } from './edit-company';
import { ListCompaniesPage } from './list-companies';
import { ViewCompanyPage } from './view-company';
import { RequireAuth } from '/src/components';

export { CreateCompanyPage, EditCompanyPage, ListCompaniesPage, ViewCompanyPage };

export const companiesRoutes: React.ReactElement[] = [
  <Route
    path="/companies/create"
    element={
      <RequireAuth>
        <CreateCompanyPage />
      </RequireAuth>
    }
  />,
  <Route
    path="/companies/:companyId/edit"
    element={
      <RequireAuth>
        <EditCompanyPage />
      </RequireAuth>
    }
  />,
  <Route
    path="/companies"
    element={
      <RequireAuth>
        <ListCompaniesPage />
      </RequireAuth>
    }
  />,
  <Route
    path="/companies/:companyId"
    element={
      <RequireAuth>
        <ViewCompanyPage />
      </RequireAuth>
    }
  />,
];
